




























































































































import { Component, Vue, Emit } from 'vue-property-decorator';
import { Job } from '@/@types/LibraryComponent';
import JobMiniCard from '@/components/jobList/table/JobMiniCard.vue';

@Component({
  components: {
    JobMiniCard,
  },
})
export default class JobHeader extends Vue {
  private theoryLogo: string = require('@/assets/logotest.png');
  private userIcon: string = require('@/assets/test.jpeg');
  private jobs: Array<Job> = require('@/repository/mock/dummyData/job/jobList.json').jobs;
  private menuIsOpen: boolean = false;

  // TODO: アプリケーションの境界とComponentの設計方針が必要
  // @Emit('open')
  private onClick(id: string): string {
    return id;
  }

  @Emit('favorite')
  private openFavorite() {
    return;
  }
}
